import React, { Component } from 'react'
import { connect } from 'react-redux'
import EquipmentTests from 'components/EquipmentTests'
import BrowserValidatorContainer from 'containers/BrowserValidatorContainer'
import {closeModal, openModal} from 'actions/modals'
import {
  CAMERA_ERROR_MODAL,
  AUDIO_ERROR_MODAL,
  SPEED_ERROR_MODAL
} from 'constants/modals'
import { setLang } from 'actions/lang'
import Header from 'components/Header'
import Footer from 'components/Footer'
import queryString from 'query-string'

class EquipmentTestsContainer extends Component {
  render() {
    const {
      showCameraErrorModal,
      showAudioErrorModal,
      showSpeedErrorModal,
      openModal,
      closeModal,
      history,
      setLang,
      locale,
      redirectURL,
      location: {
        search
      }
    } = this.props

    const showLogo = queryString.parse(search.substr(1)).show_logo === 'true'

    return (
      <BrowserValidatorContainer>
        { showLogo && (
          <Header />
        )}
        <EquipmentTests
          showCameraErrorModal={showCameraErrorModal}
          showAudioErrorModal={showAudioErrorModal}
          showSpeedErrorModal={showSpeedErrorModal}
          openModal={openModal}
          closeModal={closeModal}
          history={history}
          visitDetailsUrl={redirectURL}
          showLogo={showLogo}
        />
        <Footer
          setLang={setLang}
          locale={locale}
        />
      </BrowserValidatorContainer>
    )
  }
}

function mapStateToProps (state) {
  return {
    showCameraErrorModal: state.modal.currentModal === CAMERA_ERROR_MODAL,
    showAudioErrorModal: state.modal.currentModal === AUDIO_ERROR_MODAL,
    showSpeedErrorModal: state.modal.currentModal === SPEED_ERROR_MODAL,
    locale: state.lang.locale,
    redirectURL: state.visit.redirectURL
  }
}

function mapDispatchToProps (dispatch) {
  return {
    openModal: (modalName) => dispatch(openModal(modalName)),
    closeModal: (modalName) => dispatch(closeModal(modalName)),
    setLang: (lang) => dispatch(setLang(lang))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EquipmentTestsContainer)
